import { IOptionProductWarehouse } from 'features/inventory/products/types';
import { ITabTableLayerRow } from './types';

const getIdFromElement = (element: number | IOptionProductWarehouse): number => {
  return typeof element === 'number' ? element : Number(element?.id);
};

export const normalizePWRows = (
  elements: Array<number | IOptionProductWarehouse> = [],
  options: IOptionProductWarehouse[] = []
) => {
  const optionMap = new Map(options.map((opt) => [Number(opt.id), opt]));

  return elements
    .map((element) => {
      const id = getIdFromElement(element);
      const option = optionMap.get(id);
      const elementObj = typeof element === 'object' ? element : null;

      if (!id) {
        return null;
      }

      const product = elementObj?.product ?? option?.product;
      const description = elementObj?.description ?? option?.description;
      const warehouse = elementObj?.warehouse ?? option?.warehouse;

      if (!product) {
        return null;
      }

      return {
        id,
        product,
        description,
        warehouse
      } as ITabTableLayerRow;
    })
    .filter(Boolean) as ITabTableLayerRow[];
};
